'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** ./~/url/~/querystring/index.js
 ** module id = 304
 ** module chunks = 46 47
 **/